import React from 'react';
import {Card, Col, Container, Row} from 'react-bootstrap';
import '../layout/main.scss';
import './about.scss';
import sp_sog from '../../images/sp-sog.png';


function About() {
    return (
        <div className="App">
            <div className="about">
                <Container>
                    <h3>About</h3>
                    <div className="mn-blocks">
                        <div>It's all about us, all about us, it's all about us, all about us...</div>
                    </div>
                </Container>
            </div>
        </div>
    );
}

export default About;
